export default __webpack_public_path__ + "static/media/background.aac41424.png";